import * as yup from "yup";

export const updateInformacao = yup.object({
  titulo: yup.string().required("Título é obrigatório"),
  conteudo: yup.string()
    .required("Conteúdo é obrigatório")
    .test(
      "sem-aspas-duplas",
      'O conteúdo não pode conter aspas duplas (").',
      (value) => !value?.includes('"')
    ),
  linkEdital: yup.string().required("Link edital é obrigatório")
});
